<template>
  <pop-up-get-password v-if="isPopupPasswordVisible" v-on:close="isPopupPasswordVisible = false" @getPassword="getPassword" />
  <pop-up-confirm-pass v-if="isConfirmPassVis" v-on:close="isConfirmPassVis = false" @confirmPass="confirmPassword" />
  <pop-up-message v-if="isMessageVisible" :message="message" v-on:close="isMessageVisible = false" />
  <pop-up-loading v-if="isLoading" />

  <div class="login-page">
    <div class="login-card">
      <div class="login-card__logo">
        <img class="login-card__logo-image" :src="require('@/assets/ic_itk_logo.png')" alt="ИнТелКом" />
        <div class="login-card__brand">ИнТелКом</div>
        <div class="login-card__inn">ИНН: 6167098900</div>
      </div>

      <div class="login-card__title">{{ cardTitle }}</div>
      <div v-if="isAddMode" class="login-card__subtitle">
        Текущий аккаунт останется активным. Добавьте новый, чтобы быстро переключаться между ними.
      </div>
      <button v-if="isAddMode" type="button" class="login-card__back" @click="goBack">
        Назад
      </button>

      <div class="login-card__form">
        <label class="login-field" for="email">
          <img class="login-field__icon" :src="require('@/assets/ic_email.svg')" alt="Логин" />
          <input id="email" type="text" placeholder="Номер договора или телефона" maxlength="20" autocomplete="off" autocapitalize="off" spellcheck="false" v-model.trim="login" />
        </label>
        <label class="login-field" for="password">
          <img class="login-field__icon" :src="require('@/assets/ic_password.svg')" alt="Пароль" />
          <input
            id="password"
            :type="isPasswordVisible ? 'text' : 'password'"
            placeholder="Пароль"
            maxlength="30"
            v-model="pass"
          />
          <button
            type="button"
            class="login-field__toggle"
            :aria-label="isPasswordVisible ? 'Скрыть пароль' : 'Показать пароль'"
            :aria-pressed="isPasswordVisible.toString()"
            @click.prevent="togglePasswordVisibility"
          >
            <svg v-if="isPasswordVisible" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 5c-4.5 0-8.3 2.7-10 7 1.7 4.3 5.5 7 10 7s8.3-2.7 10-7c-1.7-4.3-5.5-7-10-7zm0 11a4 4 0 110-8 4 4 0 010 8zm0-2.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
            </svg>
            <svg v-else viewBox="0 0 24 24" aria-hidden="true">
              <path d="M3.5 4.5a1 1 0 011.4-.1l15.2 13.5a1 1 0 01-1.3 1.5l-2.2-2a10.4 10.4 0 01-4.6 1.1c-4.5 0-8.3-2.7-10-7a11.7 11.7 0 013.3-4.5L3.6 5.9a1 1 0 01-.1-1.4zM7.7 9.8a4 4 0 005.5 5.5zM12 5c4.5 0 8.3 2.7 10 7a11.9 11.9 0 01-3 4.2l-2-1.8a4 4 0 00-5.2-5.2L9.4 7.4A10.4 10.4 0 0112 5z" />
            </svg>
          </button>
        </label>

        <div class="login-card__recover" @click="isPopupPasswordVisible = true">Забыли пароль?</div>

        <div class="login-card__agreements">
          <label class="login-checkbox" for="agreement-data">
            <input id="agreement-data" type="checkbox" v-model="agreePersonalData" />
            <span class="login-checkbox__label">{{ personalDataText }}</span>
          </label>
          <label class="login-checkbox" for="agreement-docs">
            <input id="agreement-docs" type="checkbox" v-model="agreeDocuments" />
            <span class="login-checkbox__label" v-html="agreementDocumentsHtml"></span>
          </label>
          <label class="login-checkbox" for="agreement-notify">
            <input id="agreement-notify" type="checkbox" v-model="agreeNotifications" />
            <span class="login-checkbox__label">{{ notificationsText }}</span>
          </label>
        </div>

        <button class="login-card__submit" :disabled="isSubmitDisabled" @click="signIn">
          Войти
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../axios";
import {addOrUpdateAccount, syncActiveAccountFromLegacy} from "../utils/multi-account";
import PopUpMessage from "./pop-up-message";
import PopUpGetPassword from "./pop-up-get-password";
import PopUpLoading from "./pop-up-loading";
import PopUpConfirmPass from "./pop-up-confirm-pass";

const LINK_PRIVACY = "https://itk-rus.ru/politika-obrabotki-i-ispolzovaniya-personalnyix-dannyix.html";
const LINK_SERVICES = "https://itk-rus.ru/assets/doc/2025/poryadok-okazaniya-uslug-svyazi-abonentam.pdf";
const LINK_CONTRACT = "https://itk-rus.ru/soglasie-na-obrabotku-personalnyix-dannyix.html";

export default {
  name: "page-login",
  components: { PopUpConfirmPass, PopUpGetPassword, PopUpMessage, PopUpLoading },
  data() {
    return {
      isMessageVisible: false,
      isConfirmPassVis: false,
      isLoading: false,
      recordID: 0,
      isPopupPasswordVisible: false,
      message: "",
      login: "",
      pass: "",
      isPasswordVisible: false,
      agreePersonalData: false,
      agreeDocuments: false,
      agreeNotifications: false
    };
  },
  computed: {
    isAddMode() {
      return this.$route && this.$route.query && this.$route.query.mode === 'add';
    },
    cardTitle() {
      return this.isAddMode ? "Добавление аккаунта" : "Личный кабинет";
    },
    personalDataText() {
      return "Я даю согласие обработку, хранение и передачу персональных данных, в том числе третьим лицам";
    },
    notificationsText() {
      return "Я даю согласие на получение уведомлений и иной информации, в том числе рекламной об услугах и сервисах любым способом";
    },
    agreementDocumentsHtml() {
      return `Я ознакомился и согласен с <a href="${LINK_PRIVACY}" target="_blank" rel="noopener">Политикой о конфиденциальности и защите персональных данных</a>, ` +
        `<a href="${LINK_SERVICES}" target="_blank" rel="noopener">Правилами оказания услуг связи абонентам</a> и <a href="${LINK_CONTRACT}" target="_blank" rel="noopener">Договором</a>`;
    },
    isSubmitDisabled() {
      return this.isLoading ||
        !this.agreePersonalData ||
        !this.agreeDocuments ||
        !this.agreeNotifications ||
        this.login.trim() === "" ||
        this.pass === "";
    }
  },
  methods: {
    goBack() {
      this.$router.push('/');
    },
    getPassword(number, isPhone) {
      this.isLoading = true;
      axios({
        method: "POST",
        url: "v1/auth/passwordRecovery",
        headers: { Authorization: `Bearer ${localStorage.token}` },
        params: {
          login: number,
          recoveryMethod: isPhone ? "SMS" : "EMAIL"
        }
      })
        .then(response => {
          if (response.data.status === "error") {
            this.message = response.data.userMessage;
            this.isLoading = false;
            this.isMessageVisible = true;
          } else {
            this.recordID = response.data.recordID;
            this.isLoading = false;
            this.isConfirmPassVis = true;
          }
        })
        .catch(() => {
          this.message = "Ошибка при отправке запроса. Попробуйте позже";
          this.isLoading = false;
          this.isMessageVisible = true;
        });
    },

    confirmPassword(code) {
      this.isConfirmPassVis = false;
      this.isLoading = true;
      axios({
        method: "POST",
        url: "v1/auth/passwordRecovery/confirm",
        headers: { Authorization: `Bearer ${localStorage.token}` },
        params: {
          recordID: this.recordID,
          acceptCode: code
        }
      })
        .then(response => {
          if (response.data.status === "error") {
            this.message = response.data.userMessage;
            this.isLoading = false;
            this.isMessageVisible = true;
          } else {
            this.message = "Успешно";
            this.isLoading = false;
            this.isMessageVisible = true;
          }
        })
        .catch(() => {
          this.message = "Ошибка при подтверждении пароля. Попробуйте позже";
          this.isLoading = false;
          this.isMessageVisible = true;
        });
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    signIn() {
      if (this.isSubmitDisabled) {
        this.message = "Убедитесь, что заполнили логин, пароль и приняли условия обслуживания";
        this.isMessageVisible = true;
        return;
      }

      const login = this.login.trim();
      const password = this.pass;

      if (!login) {
        this.message = "Заполните поле \"Логин\"";
        this.isMessageVisible = true;
        return;
      }
      if (!password) {
        this.message = "Заполните поле \"Пароль\"";
        this.isMessageVisible = true;
        return;
      }

      this.isLoading = true;
      axios({
        method: "POST",
        url: "v2/auth",
        data: {
          login,
          pass: password
        }
      })
        .then(response => {
          if (response.data.status === "OK") {
            const token = response.data.access_token;
            const userID = response.data.user_id;
            addOrUpdateAccount({token, login, userID});
            localStorage.agreementAccepted = 'false';
            syncActiveAccountFromLegacy();
            this.$router.push("/");
          } else {
            this.message = response.data.userMessage || "Не удалось авторизоваться. Попробуйте ещё раз";
            this.isMessageVisible = true;
          }
        })
        .catch(() => {
          this.message = "Ошибка при выполнении запроса. Повторите попытку позднее";
          this.isMessageVisible = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f4f7fb;
}

.login-card {
  width: min(440px, 100%);
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 24px 48px rgba(43, 89, 120, 0.14);
}

.login-card__logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.login-card__logo-image {
  width: 200px;
  height: auto;
}

.login-card__brand {
  font-family: 'Mont', serif;
  font-weight: 800;
  font-size: 2rem;
  color: #24484e;
  text-align: center;
}

.login-card__inn {
  font-family: 'Mont', serif;
  font-weight: 600;
  font-size: 1rem;
  color: #6c7b8a;
  text-align: center;
}

.login-card__title {
  font-family: 'Mont', serif;
  font-weight: 700;
  font-size: 1.35rem;
  color: #24484e;
  text-align: center;
}

.login-card__subtitle {
  margin-top: -12px;
  font-family: 'Mont', serif;
  font-size: 0.95rem;
  line-height: 1.4;
  color: #6a8b9b;
  text-align: center;
}

.login-card__back {
  align-self: center;
  margin-top: -4px;
  background: transparent;
  border: none;
  color: #2d666e;
  font-family: "Mont", serif;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s ease;
}

.login-card__back:hover,
.login-card__back:focus-visible {
  color: #0082bf;
}

.login-card__form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-field {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 16px;
  border: 1px solid #e0e7ee;
  background: #f7fafb;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.login-field:focus-within {
  border-color: #0082bf;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(0, 130, 191, 0.12);
}

.login-field__icon {
  width: 24px;
  height: 24px;
}

.login-field input {
  flex: 1;
  border: none;
  background: transparent;
  font-family: 'Mont', serif;
  font-size: 1rem;
  color: #24484e;
  outline: none;
}

.login-field__toggle {
  border: none;
  background: none;
  padding: 4px;
  margin-left: 4px;
  cursor: pointer;
  color: #6c7b8a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.login-field__toggle svg {
  width: 20px;
  height: 20px;
  fill: currentColor;
}

.login-field__toggle:hover {
  color: #24484e;
}

.login-field__toggle:focus-visible {
  outline: 2px solid #0082bf;
  outline-offset: 2px;
  border-radius: 6px;
}

.login-card__recover {
  align-self: flex-end;
  font-family: 'Mont', serif;
  font-size: 0.9rem;
  color: #0082bf;
  cursor: pointer;
  transition: color 0.2s ease;
}

.login-card__recover:hover {
  color: #006a99;
  text-decoration: underline;
}

.login-card__agreements {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.login-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.login-checkbox input {
  margin-top: 2px;
  width: 20px;
  height: 20px;
  accent-color: #0082bf;
}

.login-checkbox__label {
  font-family: 'Mont', serif;
  font-size: 0.85rem;
  color: #4a5a64;
  line-height: 1.4;
}

.login-checkbox__label a {
  color: #0082bf;
  font-weight: 600;
  text-decoration: underline;
}

.login-card__submit {
  margin-top: 8px;
  border: none;
  border-radius: 16px;
  padding: 14px;
  font-family: 'Mont', serif;
  font-weight: 700;
  font-size: 1rem;
  color: #ffffff;
  background: #0082bf;
  box-shadow: 0 16px 32px rgba(0, 130, 191, 0.22);
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease, box-shadow 0.2s ease;
}

.login-card__submit:hover:enabled {
  transform: translateY(-1px);
  opacity: 0.95;
}

.login-card__submit:disabled {
  background: #a6b4c2;
  box-shadow: none;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .login-card {
    padding: 24px;
    gap: 20px;
  }

  .login-card__logo-image {
    width: 160px;
  }
}
</style>
